import { Input, makeStyles } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { editBtnText } from 'src/store/modules/buttons';
import EditMultiBtnAgain from '../EditMultiBtnAgain';

interface editBtnProps {
  menuTitle?: string;
  type: string;
}

const useStyles = makeStyles(() => ({
  root: {
    padding: '1.5rem 1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
    border: '1px solid #dddddd'
  },
  fontBox: {
    width: '100%',
    height: '2.5rem',
    padding: '0 0.78rem',

    cursor: 'pointer',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,

    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #D9D9D9'
  },
  input: {
    padding: '1rem',
    border: 0,
    outline: 'none',
    overflow: 'hidden',

    '&:focus': {
      border: 0,
      outline: 'none'
    },

    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: '1.2rem',
    letterSpacing: '0.015rem'
  },

  bottomBtn: {
    padding: '0.5rem',

    display: 'flex',
    justifyContent: 'space-between',
    borderTop: '1px solid #dddddd',
    backgroundColor: '#F2F2F2'
  },
  btnMinusPlus: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem',
    padding: 0,
    display: 'flex'
  },

  fontNumber: {
    width: '3rem',
    height: '1.5rem',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,

    borderRadius: '0.25rem',
    border: '1px solid #D9D9D9',
    backgroundColor: '#fff'
  },

  buttonWrapper: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem'
  },
  buttonImage: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem'
  },

  boxWrapper: {
    // margin: '0 0.5rem',
    display: 'flex',
    justifyContent: 'space-between'
  },
  colorBox: {
    padding: '0.25rem 0.5rem',
    borderRadius: '0.25rem',
    border: '1px solid #D9D9D9',
    textAlign: 'center',

    color: '#000',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400
  },
  textAlign: {
    cursor: 'pointer'
  }
}));

const EditMultiSurvey: FC<editBtnProps> = ({ menuTitle, type }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  const btnText = useSelector((state: RootState) => state.buttons.btnText);

  const [key, setKey] = useState(false);
  const handleKey = e => {
    if (e.key === 'Enter') setKey(true);
    else setKey(false);
  };
  const handleBtnSurvey = (e, idx) => {
    const textSplit = e.target.value.split('');
    if (key || textSplit[textSplit.length - 1] === '\\') return;
    const newBtnJson = btnText?.[type]?.slice();
    const newBtnArray = btnText?.[type]?.[currentIndex]?.slice();
    newBtnArray.splice(idx, 1, e.target.value.split('\n').join('\\n'));
    newBtnJson.splice(currentIndex, 1, newBtnArray);
    const newBtnText = JSON.parse(
      `{"${type}": [${newBtnJson?.map(
        (btnArray: any, idx: number) =>
          `[${btnArray.map((data: any, idx2: number) => `"${data}"`)}]`
      )}]}`
    );
    dispatch(editBtnText({ ...btnText, ...newBtnText }));
  };

  return (
    <div className={classes.root}>
      <div
        style={{
          fontSize: '0.875rem',
          fontWeight: 600,
          fontFamily: 'Archivo',
          letterSpacing: '0.0175rem'
        }}
      >
        OPTIONS
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem'
        }}
      >
        {btnText?.[type]?.[currentIndex]?.map((text: string, idx: number) => (
          <div
            key={idx}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.5rem'
            }}
          >
            <div className={classes.container}>
              <Input
                className={classes.input}
                multiline
                value={text}
                onChange={e => handleBtnSurvey(e, idx)}
                onKeyPress={handleKey}
                disableUnderline
              />
            </div>
            <EditMultiBtnAgain
              type={type}
              currentIndex={currentIndex}
              idx={idx}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default EditMultiSurvey;
